// WP-07 — empty screen shell for O-02…O-15. The real feature modules (Track E
// WP-10…WP-17) replace these one vertical at a time; the route, RBAC grant and
// title are already the contract-final ones (LLD-05 Appendix A).
import { t } from "../i18n/i18n";
import type { ScreenDef } from "./registry";

export function ScreenPlaceholder({ screen }: { screen: ScreenDef }) {
  return (
    <section className="placeholder" aria-labelledby={`screen-${screen.id}`}>
      <p className="placeholder__code">{screen.id}</p>
      <h1 id={`screen-${screen.id}`}>{t(screen.titleKey)}</h1>
      <p>{t("placeholder.body")}</p>
    </section>
  );
}

export function NotFound() {
  return (
    <section className="placeholder">
      <h1>{t("notFound.title")}</h1>
      <p>{t("notFound.body")}</p>
    </section>
  );
}
